import Typography from '@mui/material/Typography';
import Container from '@mui/system/Container';

import TextEditor from 'front/CLIENT_RichTextEditor';
import Master from 'front/MasterAdmin';
import React from 'react';


export const Test = () => {

    const [html, setHtml] = React.useState('<p>my <b>HTML</b></p>');

    function onChange(e: any) {
        console.log('HTML changed:', e.target.value);
        setHtml(e.target.value);
    }

    return <Master>
        <Container maxWidth={false}><Typography variant={'h1'}>Test</Typography>
            <TextEditor html={html} onChange={onChange} />
        </Container></Master>
        ;
};
